import { AbstractControlOptions, FormBuilder, FormGroup } from '@angular/forms';

export interface FieldMeta {
  key: string;
  wireKey: string;
  label: string;
  required?: boolean;
  defaultOn?: boolean;
}

export const RESULT_FIELD_META: FieldMeta[] = [
  { key: 'url',             wireKey: 'url',              label: 'URL', required: true },
  { key: 'domainName',      wireKey: 'domain_name',      label: 'Domain name', defaultOn: true },
  { key: 'relevanceScore',  wireKey: 'relevance_score',  label: 'Relevance score' },
  { key: 'indexationDate',  wireKey: 'indexation_date',  label: 'Indexation date' },
  { key: 'author',          wireKey: 'author',           label: 'Author' },
  { key: 'content',         wireKey: 'content',          label: 'Content (if legal)' },
  { key: 'imageUrl',        wireKey: 'image_url',        label: 'Image URL' },
  { key: 'title',           wireKey: 'title',            label: 'Title', defaultOn: true },
  { key: 'publicationDate', wireKey: 'publication_date', label: 'Publication date' },
  { key: 'favicon',         wireKey: 'favicon',          label: 'Favicon' },
  { key: 'description',     wireKey: 'description',      label: 'Description' },
  { key: 'language',        wireKey: 'language',         label: 'Language' },
];

export function buildFieldsGroup(fb: FormBuilder, meta: FieldMeta[], options?: AbstractControlOptions): FormGroup {
  return fb.group(
    Object.fromEntries(meta.map(f => [
      f.key,
      f.required
        ? fb.control({ value: true, disabled: true })
        : fb.control(!!f.defaultOn),
    ])),
    options,
  );
}

export function flattenFields(meta: FieldMeta[], fieldsValue: Record<string, boolean>): Record<string, boolean> {
  const fields: Record<string, boolean> = {};
  meta.forEach(f => {
    fields[`include_${f.wireKey}`] = fieldsValue[f.key];
  });
  return fields;
}

/** `sort_by` values the API accepts (see docs-api-data.ts); shared by
 *  /search, /similar and /image. */
export const SORT_OPTIONS: { value: string; label: string }[] = [
  { value: 'relevance', label: 'Relevance' },
  { value: 'publication_date', label: 'Publication date' },
  { value: 'indexation_date', label: 'Indexation date' },
];
